"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrgProvidedInputParams = void 0;
const common_1 = require("@finley-technologies/common");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const createOrgProvidedInputParams = ({ postgresQuery, }) => {
    const { parameterConfig, variables } = postgresQuery;
    const { key, reportingPeriod, reportingDateFormula } = parameterConfig;
    try {
        const reportingDate = formula_engine_1.commonFormulas.evaluateDateFormula({
            dateFormula: reportingDateFormula.formula,
            variables,
        });
        return {
            isValid: true,
            params: {
                key: key.key,
                reportingDate,
                reportingPeriod: reportingPeriod.reportingPeriod,
            },
        };
    }
    catch (err) {
        const errorMessage = `Detected error while creating Org Provided Input params [error:${(0, common_1.getErrorMessage)(err)}`;
        return {
            isValid: false,
            errors: [errorMessage],
        };
    }
};
exports.createOrgProvidedInputParams = createOrgProvidedInputParams;
//# sourceMappingURL=orgProvidedInputParams.js.map